import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import { ItemCategory as ItemCategoryResponse } from '@models/item/itemCategory';
import { CategoryKitIcon } from '@models/item/itemCategory/extension';
import { useStepFlow } from '@router/stackflow';
import classNames from 'classnames/bind';
import { useContext } from 'react';

import styles from './styles.module.scss';
import ShopItemContext from '../../../../../context/ShopItemContext';

interface Props {
    itemCategory: ItemCategoryResponse;
    categories: ItemCategoryResponse[];
}

const cx = classNames.bind(styles);

function ItemCategory({
  itemCategory, categories,
}:Props) {
  const { shopId, categoryId } = useContext(ShopItemContext);
  const { stepReplace } = useStepFlow('ItemsActivity');
  const currentCategoryId = categoryId || categories[0]?.id;
  const {
    id, name, iconImageUrl, iconKit, iconType,
  } = itemCategory;
  const selected = currentCategoryId === id;
  const onClick = () => {
    stepReplace({
      shopId, categoryId: id, type: 'ALL',
    });
  };
  const Icon = iconKit ? CategoryKitIcon[iconKit] : undefined;
  return (
      <button className={cx(
        'container',
        { selected },
      )}
              onClick={onClick} >
          {(iconType === 'IMAGE' && iconImageUrl) && (
              <Image src={iconImageUrl}
                     width={24}
                     height={24}
                     className={styles.icon} />
          )}
          {(iconType === 'KIT' && Icon) && (
              <Icon color={colors.primary}
                    size={24} />
          )}
          <Text size='lg'
                fontWeight={selected ? 'bold' : 'regular'}
                color={selected ? colors.buttonText : colors.textSecondary}>
              {name}
          </Text>
      </button>
  );
}

export default ItemCategory;
